import React, { ReactElement, useEffect } from 'react';
import TopSection from './TopSection';
import { useDispatch } from 'react-redux';
import { fetchActivities, fetchArticles, fetchCarousel, fetchPaKryss, fetchStartPuffs, fetchStartSponsors } from '../../../actions';
import CarouselSection from './CarouselSection';
import StartPuffsSection from './StartPuffSection';
import StartSponsorsSection from './StartSponsorsSection';

export default function FrontPageWrapper(): ReactElement {
  const dispatch = useDispatch();
  useEffect(() => {
    fetchActivities(dispatch)().catch((e) => console.error(`Failed to load activities`, e));
    fetchArticles(dispatch)().catch((e) => console.error(`Failed to load articles`, e));
    fetchCarousel(dispatch)().catch((e) => console.error(`Failed to load carousel`, e));
    fetchPaKryss(dispatch)().catch((e) => console.error(`Failed to load På Kryss`, e));
    fetchStartPuffs(dispatch)().catch((e) => console.error(`Failed to load Start puffs`, e));
    fetchStartSponsors(dispatch)().catch((e) => console.error(`Failed to load Start sponsors`, e));
  }, [dispatch]);
  return (
    <>
      <CarouselSection />
      <TopSection />
      <StartPuffsSection />
      <StartSponsorsSection />
    </>
  );
}
